module.exports = __webpack_public_path__ + "img/ban_5.7c837918.png";